<template>
  <div>
    <v-carousel
      :height="$vuetify.breakpoint.mdAndUp ? '80vh' : '90vh'"
      width="100vw"
      id="home"
      show-arrows-on-hover
    >
      <v-carousel-item v-for="(item, index) in gallery" :key="index">
        <v-img
          gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)"
          :src="$webp ? item.imgWebp : item.imgJpg"
          style="position: relative;"
          :height="$vuetify.breakpoint.mdAndUp ? '80vh' : '90vh'"
        >
          <div
            style="height: 100%;"
            class="d-flex justify-center align-center flex-column"
          >
            <h1
              class="display-1 mb-6 font-weight-bold white--text text-center customFont"
            >
              {{ item.sectionText }}
            </h1>
            <v-btn
              :href="item.action"
              color="white"
              class="primary--text font-weight-bold"
              large
            >
              {{ item.btnText }}
            </v-btn>
          </div>
        </v-img>
      </v-carousel-item>
      <div class="div-position">
        <div class="d-flex flex-row align-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <a
                v-on="on"
                href="/AVISO_PRIVACIDAD.pdf"
                download
                target="_blank"
                class="white--text"
                style="text-decoration: none;"
              >
                <v-img
                  width="40"
                  class="mx-3"
                  src="imagenes/aviso_de_privacidad.png"
                ></v-img>
              </a>
            </template>
            <span>Aviso de privacidad</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <a
                v-on="on"
                href="/POLITICA_CALIDAD.pdf"
                download
                target="_blank"
                class="white--text"
                style="text-decoration: none;"
              >
                <v-img width="40" class="mx-3" src="imagenes/iso.png"></v-img>
              </a>
            </template>
            <span>Politica de calidad</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-img
                width="40"
                src="imagenes/LOGO_BURO.png"
                v-on="on"
                @click.stop="modalburo = true"
                class="white--text mx-3"
              ></v-img>
            </template>
            <span>Buró de entidades financieras</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-img
                width="40"
                contain
                src="imagenes/CONDUSEF.png"
                v-on="on"
                @click.stop="modalCONDUSEF = true"
                class="white--text mx-3"
              ></v-img>
            </template>
            <span>CONDUSEF</span>
          </v-tooltip>
        </div>
      </div>
    </v-carousel>
    <v-container class="py-0">
      <v-row>
        <v-col cols="12" sm="12" md="6" class="pa-0">
          <vc-color-banner
            :text="colorBannerText"
            :title="colorBannerTitle"
          ></vc-color-banner>
        </v-col>
        <v-col cols="12" sm="12" md="6" class="pa-0">
          <vc-white-banner
            :text="whiteBannerText"
            title="Crédito Nómina"
            subtitle="Aplica solo para reestructura de créditos"
            image="imagenes/image_9.jpg"
            route="/personal-credit"
          ></vc-white-banner>
        </v-col>
        <v-col cols="12" sm="12" md="6" class="pa-0">
          <vc-white-banner
            :text="whiteBannerText"
            subtitle="Aplica solo para reestructura de créditos"
            title="Crédito MIPYME"
            image="imagenes/image_10.jpg"
            route="/mipyme-credit"
          ></vc-white-banner>
        </v-col>
        <v-col cols="12" sm="12" md="6" class="pa-0">
          <vc-white-banner
            :text="whiteBannerText"
            title="Crédito PYME"
            subtitle="Aplica solo para reestructura de créditos"
            image="imagenes/image_8.jpg"
            route="/pyme-credit"
          ></vc-white-banner>
        </v-col>
      </v-row>
    </v-container>
    <vc-sucursales></vc-sucursales>

    <vc-contact
      :imgleft="true"
      :image="`imagenes/contacto.jpg`"
      :title="primaryBanner3Text"
    ></vc-contact>
    <vc-politic :image="`imagenes/logo.svg`"></vc-politic>
    <vc-footer></vc-footer>
    <!-- <vc-modal :image="`imagenes/logo.svg`"></vc-modal> -->
    <v-dialog v-model="modalburo" max-width="800">
      <v-card>
        <v-card-title class="headline"
          >Buró de entidades financieras</v-card-title
        >

        <v-card-text>
          <v-img
            max-width="100"
            class="mb-3"
            :src="`imagenes/logo_buro.jpg`"
          ></v-img>
          <p v-html="burotext1" class="font-weight-bold"></p>
          <p v-html="burotext2" class="font-weight-bold"></p>
          <p v-html="burotext3" class="font-weight-bold"></p>
          <p v-html="burotext4" class="font-weight-bold"></p>
          <p v-html="burotext5" class="font-weight-bold"></p>
          <p class="font-weight-bold black--text">
            Información de Impulsora y Fomento Alica S.A.P.I. de C.V. Sofom
            E.N.R.
          </p>
          <p class="font-weight-bold">
            Descarga los siguentes documentos para conocer la Información
            deImpulsora y Fomento Alica S.A.P.I. de C.V. Sofom E.N.R. en el Buró
            de Entidades Financieras:
          </p>
          <ul>
            <li
              class="font-weight-bold my-2"
              v-for="(item, index) in linksburo"
              :key="index"
            >
              <a
                :href="item.link"
                target="_blank"
                v-html="item.text"
                style="text-decoration: none;"
              ></a>
            </li>
          </ul>
          <p class="font-weight-bold">
            La información que se detalla corresponde única y exclusivamente a
            Impulsora y Fomento Alica S.A.P.I. de C.V. Sofom E.N.R.
          </p>
          <p class="font-weight-bold black--text">Información del sector</p>
          <p v-html="burotext6" class="font-weight-bold"></p>
          <p class="font-weight-bold black--text">
            Información de Buró de Entidades Financieras
          </p>
          <p class="font-weight-bold">
            <strong class="black--text">Producto:</strong> Credito Nomina
          </p>
          <p class="font-weight-bold">
            <strong class="black--text">Tipo:</strong> Otorgamiento de Crédito
          </p>
          <p class="font-weight-bold">
            <strong class="black--text">Calificación del Producto:</strong> 7.75
          </p>
          <a
            class="font-weight-bold"
            href="https://www.buro.gob.mx/tbl_productos.php?id_producto=3&id_periodo=23&id_sector=69#"
            target="_blank"
            >Consultar Evaluación de CONDUSEF para Impulsora y Fomento Alica
            S.A.P.I. de C.V. Sofom E.N.R.</a
          >
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="modalburo = false"
            class="boldFont"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalCONDUSEF" max-width="800">
      <v-card>
        <v-card-title class="headline">CONDUSEF</v-card-title>

        <v-card-text>
          <p v-html="CONDUSEFtext1" class="font-weight-bold"></p>
          <p v-html="CONDUSEFtext2" class="font-weight-bold"></p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="modalCONDUSEF = false"
            class="boldFont"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    linksburo: [
      {
        text: "Al periodo de Enero a Junio del 2019",
        link:
          "https://drive.google.com/open?id=1ZRuFTSEegiQv_LnHMMeuioqrlgMyuh6O",
      },
      {
        text: "Al periodo de Enero a Diciembre del 2018",
        link:
          "https://drive.google.com/open?id=1jQJeyEV59og-QOrNDyAGXTTUCS5jhEDF",
      },
      {
        text: "Al periodo de Enero a Diciembre del 2017",
        link:
          "https://drive.google.com/open?id=1ylVzDQ4ypvwTay0yWlC7gI6-jGjwDbLp",
      },
      {
        text: "Al periodo de Enero a Diciembre del 2016",
        link:
          "https://drive.google.com/open?id=1I7nTwOc1Z89Fq0nbg3eavp_Ml2DZl5Lv",
      },
      {
        text: "Al periodo de Enero a Diciembre del 2015",
        link:
          "https://drive.google.com/open?id=1QZbPBYN1bhkatWmmeTACvkTSa8Bfg6WR",
      },
      {
        text: "Al periodo de Enero a Diciembre del 2014",
        link:
          "https://drive.google.com/open?id=1_BNCQrHTLeMMdk7RnLvYwBu_q9HNogfo",
      },
    ],
    modalburo: false,
    cycle: true,
    hideDelimiters: true,
    arrows: true,
    modalCONDUSEF: false,
    colorBannerTitle: "",
    colorBannerText:
      "Aplica para reestructuras de crédito y financiamiento de polizas de seguro",
    CONDUSEFtext1:
      "IMPULSORA Y FOMENTO ÁLICA, S.A.P.I. DE C.V., SOFOM E.N.R. recibe las consultas, reclamaciones o aclaraciones en su Unidad Especializada de Atención a Usuarios ubicada en Av. Juárez 83 Ote, Col. Centro C.P 63000 Tepic, Nayarit, México. Al correo electrónico ifa_une@capitalica.com.mx ,o teléfono (311) 133 45 29 con atención al Titular de la UNE, en un Horario de 9: 00 am a 2:00 pm y de 4:00 pm a 7:00 de lunes a viernes, así como en cualquiera de nuestras sucursales y oficinas.",
    CONDUSEFtext2:
      "En caso que sus dudas, consultas sobre comisiones para fines informativos, quejas o reclamaciones, no fueran resueltas satisfactoriamente en alguna de nuestras sucursales, podrá acudir a la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (CONDUSEF), con domicilio San Luis Sur 136, Centro, Código Postal 63000 Tepic, Nayarit, México. Al correo electrónico naycond@condusef.gob.mx, teléfono (01) (311) 133 33 09, (01) (311) 133 33 13 y lada sin costo 01 800 999 8080, o consultar la página electrónica en internet <a target='_blank' href='https://www.gob.mx/condusef'>www.condusef.gob.mx</a>.",
    burotext1:
      "Es una herramienta de consulta y difusión con la que podrás conocer los productos que ofrecen las entidades financieras, sus comisiones y tasas, las reclamaciones de los usuarios, las prácticas no sanas en que incurren, las sanciones administrativas que les han impuesto, las cláusulas abusivas de sus contratos y otra información que resulte relevante para informarte sobre su desempeño.",
    burotext2:
      "Con el Buró de Entidades Financieras, se logrará saber quién es quién en bancos, seguros, sociedades financieras de objeto múltiple, cajas de ahorro, afores, entre otras entidades. Con ello, podrás comparar y evaluar a las entidades financieras, sus productos y servicios y tendrás mayores elementos para elegir lo que más te convenga.",
    burotext3:
      "Esta información te será útil para elegir un producto financiero y también para conocer y usar mejor los que ya tienes.",
    burotext4:
      "Este Buró de Entidades Financieras, es una herramienta que puede contribuir al crecimiento económico del país, al promover la competencia entre las instituciones financieras; que impulsará la transparencia al revelar información a los usuarios sobre el desempeño de éstas y los productos que ofrecen y que va a facilitar un manejo responsable de los productos y servicios financieros al conocer a detalle sus características.",
    burotext5:
      "Lo anterior, podrá derivar en un mayor bienestar social, porque al conjuntar en un solo espacio tan diversa información del sistema financiero, el usuario tendrá más elementos para optimizar su presupuesto, para mejorar sus finanzas personales, para utilizar correctamente los créditos que fortalecerán su economía y obtener los seguros que la protejan, entre otros aspectos.",
    burotext6:
      "La información corresponde únicamente a las Entidades Financieras integrantes de Impulsora y Fomento Alica S.A.P.I. de C.V. Sofom E.N.R., para conocer la información de cada sector, se podrá acceder al sitio <a href='http://www.buro.gob.mx'>http://www.buro.gob.mx</a>.",

    primarBanneryText: "",
    whiteBannerText: "",
    whiteBannerText2: "",
    primaryBanner2Title: "¿Automóvil nuevo? <br> Te lo mereces",
    primaryBanner2Text: "Te financiamos hasta un 80% del costo del vehículo.",
    primaryBanner3Text: "Quejas y Sugerencias",
    gallery: [
      {
        imgWebp: "imagenes/principal.webp",
        imgJpg: "imagenes/principal.jpg",
        btnText: "CONÓCENOS",
        href: "#banner_color",
        sectionText: "El efectivo que te hace fuerte",
      },
      {
        imgWebp: "imagenes/credito_mipyme.webp ",
        imgJpg: "imagenes/credito_mipyme.jpg",
        btnText: "REQUISITOS",
        href: "#banner_primary",
        sectionText: "Crédito MIPYME",
      },
      {
        imgWebp: "imagenes/personal.webp ",
        imgJpg: "imagenes/personal.jpg",
        btnText: "REQUISITOS",
        href: "#banner_white",
        sectionText: "Crédito Nómina",
      },
      {
        imgWebp: "imagenes/credito_pyme.webp ",
        imgJpg: "imagenes/credito_pyme.jpg",
        btnText: "REQUISITOS",
        href: "#banner_white2",
        sectionText: "Crédito PYME",
      },
    ],
  }),
};
</script>
<style scoped>
.div-position {
  position: absolute;
  bottom: 10%;
  right: 5%;
}

h1 {
  font-family: "Eras Medium ITC" !important;
}
.customFont {
  font-family: "Eras Medium ITC" !important;
}
.custom-link {
  text-decoration: none;
  font-size: 2rem;
  color: #bdbdbd;
  height: 100px;
  width: 100px;
  margin: 1rem;
}
.bg-white {
  background-color: #ffffff !important;
}
.container {
  max-width: 2785px !important;
}
.bg-primary_dark {
  background: #8a172b !important;
}
.boldFont {
  font-weight: bold !important;
}
</style>
